import styled, { css } from 'styled-components';

export const ScDialog = styled.div<{
  isLongOffer?: boolean;
  isHasTerms?: boolean;
  disabled?: boolean;
}>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #f0c018;
  font-style: normal;
  text-transform: uppercase;
  font-weight: 700;
  width: 100%;
  height: 100%;
  border: 16px solid transparent;
  border-radius: 50%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  max-width: 90%;

  ${({ isHasTerms }) =>
    isHasTerms &&
    css`
      justify-content: flex-start;
      padding-top: 60px;
    `}
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  & .dialog__title {
    font-size: 32px;
    margin-bottom: 32px;
  }

  & .dialog__subTitle {
    font-size: 22px;
    margin-bottom: 12px;
  }

  & .dialog__main {
    color: #fff;
    font-size: ${({ isLongOffer }) => (isLongOffer ? '36px' : '40px')};
    margin-bottom: 32px;
    max-width: 95%;

    & span {
      font-size: 32px;
    }
    &:has(+ .dialog__haveTry) {
      margin-bottom: 1rem;
    }
  }

  & .dialog__haveTry {
    font-size: 22px;
    margin-bottom: 2rem;
  }

  & button {
    color: #821f00;
    font-size: 22px;
    line-height: 1.1;
    white-space: nowrap;
    border-radius: 40px;
    background: linear-gradient(180deg, #ffeb7d 5.44%, #bf610f 99.56%);
    padding: 12px 24px;
    font-weight: 700;
    text-transform: uppercase;
    min-width: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    user-select: none;
    margin-bottom: 1rem;

    &:hover {
      box-shadow: 0px 0px 18px 5px rgb(244 193 52 / 32%);
    }
  }

  & button.link-button {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  }
`;
